(() => {
  const enhanceReviewWidget = (section) => {
    if (!section || section.dataset.reviewsEnhanced === 'true') return true;

    const widget = section.querySelector('.jdgm-rev-widg');
    const badge = section.querySelector('[data-product-reviews-verified]');
    const summary = widget?.querySelector('.jdgm-rev-widg__summary');
    if (!widget || !badge || !summary) return false;

    summary.append(badge);
    badge.hidden = false;
    section.dataset.reviewsEnhanced = 'true';
    return true;
  };

  const initialize = (section) => {
    if (enhanceReviewWidget(section)) return;

    const observer = new MutationObserver(() => {
      if (enhanceReviewWidget(section)) observer.disconnect();
    });
    observer.observe(section, { childList: true, subtree: true });
  };

  document.querySelectorAll('[data-product-reviews]').forEach(initialize);
})();
